import type { ReactNode } from 'react'
import { Search } from 'lucide-react'
import { Input } from '@/components/ui/Input'
import { Select } from '@/components/ui/Select'
import { Button } from '@/components/ui/Button'

type FilterOption = { value: string; label: string }

type FilterBarProps = {
  search: string
  onSearchChange: (value: string) => void
  searchPlaceholder?: string
  filterLabel?: string
  filterValue?: string
  filterOptions?: FilterOption[]
  onFilterChange?: (value: string) => void
  extra?: ReactNode
  filterWidth?: string
}

export function FilterBar({
  search,
  onSearchChange,
  searchPlaceholder = 'Tìm kiếm...',
  filterLabel = 'Bộ lọc',
  filterValue,
  filterOptions,
  onFilterChange,
  extra,
  filterWidth = 'w-64',
}: FilterBarProps) {
  return (
    <div className="mb-3 flex flex-wrap items-center gap-2">
      <div className="relative min-w-[240px] flex-1">
        <Search className="pointer-events-none absolute top-1/2 left-2.5 h-4 w-4 -translate-y-1/2 text-slate-400" />
        <Input
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={searchPlaceholder}
          className="pl-8"
          aria-label={searchPlaceholder}
        />
      </div>
      {filterOptions && onFilterChange ? (
        <div className={`w-full sm:w-auto ${filterWidth}`}>
          <Select
            aria-label={filterLabel}
            value={filterValue}
            onChange={(e) => onFilterChange(e.target.value)}
            options={filterOptions}
          />
        </div>
      ) : (
        <Button variant="secondary" type="button" disabled>
          {filterLabel}
        </Button>
      )}
      {extra}
    </div>
  )
}
